<template>
  <div>
    <b-modal
      id="delete-modal"
      ref="delete-partner"
      size="md"
      centered
      hide-footer
      hide-header
    >
      <div class="pb-2 px-2">
        <b-row>
          <b-col>
            <p class="main-header">Are you sure?</p>
            <p class="plain-text">
              If you want to delete, then type
              <span> {{ confirmInput }}</span> and press DELETE
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <p class="plain-text">Enter Correct Text</p>
          </b-col>
          <b-col class="pr-2">
            <c-input
              inputType="text"
              inputId="username"
              labelText="Type here..."
              v-model="confirmText"
            />
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="d-flex justify-content-end">
            <b-button
              variant="danger"
              class=" btn-text"
              @click="closeModal"
              >CANCEL</b-button
            >
          </b-col>
          <b-col class="d-flex justify-content-start">
            <b-button variant="danger" class="btn-text" @click="initDelete"
              >DELETE</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import cInput from "@/components/FormElements/CustomInput";
export default {
  components: {
    cInput,
  },
  props: {
    confirmInput: {
      default: "Delete",
      type: String,
    },
  },
  data() {
    return {
      confirmText: "",
    };
  },
  methods: {
    closeModal() {
      this.$refs["delete-partner"].hide();
      this.confirmText = "";
    },
    openModal() {
      this.$refs["delete-partner"].show();
    },
    initDelete() {
      if (this.confirmText.toLowerCase() === this.confirmInput.toLowerCase()) {
        this.$emit("proceed-delete");
        this.closeModal();
      } else {
        this.$toasted.error("Wrong Input!!");
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
.main-header {
  font-size: 24px;
  font-weight: 700;
  color: var(--primary);
}
.plain-text {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
.plain-text span {
  font-size: 17px;
  font-weight: 600;
}
.btn-text {
  font-size: 14px !important;
}
</style>
